class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.headerSubmenu = this.mainDetailsToggle.querySelector('.header__submenu');

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.headerSubmenu
      .animate([{ transform: 'translateY(-15px)', opacity: 0 }], {
        duration: 200,
        easing: 'ease-in-out',
        fill: 'forwards',
      })
      .finished.then(() => {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      });
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.mainDetailsToggle.addEventListener('click', this.onClick.bind(this));
    this.mainDetailsToggle.querySelectorAll('a.header__menu-item').forEach((item) => {
      item.addEventListener('click', this.closeImmediately.bind(this));
    });
  }

  closeImmediately() {
    this.headerSubmenu
      .animate([{ transform: 'translateY(-15px)', opacity: 0 }], {
        duration: 100,
        easing: 'ease-in-out',
        fill: 'forwards',
      })
      .finished.then(() => {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      });
  }

  onClick(event) {
    event.preventDefault();
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', true);
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      this.headerSubmenu.animate([{ transform: 'translateY(0)', opacity: 1 }], {
        duration: 200,
        easing: 'ease-in-out',
        fill: 'forwards',
      });
    } else {
      this.headerSubmenu
        .animate([{ transform: 'translateY(-15px)', opacity: 0 }], {
          duration: 200,
          easing: 'ease-in-out',
          fill: 'forwards',
        })
        .finished.then(() => {
          this.mainDetailsToggle.removeAttribute('open');
          this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
        });
    }
  }

  onToggle(event) {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
